module.exports = __webpack_public_path__ + "static/logo7-e75ef04e9f30078b3b49779a7a368c3c.svg";